<template>
  <header class="the-header">
    <section class="title">
      <img
        src="https://d33wubrfki0l68.cloudfront.net/d30720df7b674a35e8cc6ad6ed79bdc5f01e6d10/0de31/img/logo.png"
        alt="ロゴ"
      />
      <span></span>
      <h1>
        【ETUMAX公式】
        <br />
        ロイヤルハニー購入サイト
      </h1>
    </section>
    <div class="icons">
      <a
        href="https://royalhoney.company/cart"
        target="_blank"
        rel="noopener noreferrer"
        class="cart"
      >
        <img
          src="https://d33wubrfki0l68.cloudfront.net/3f5f0d2391a4ce17209f207858bf7b35b848eb66/cb83a/img/icons/shoppingcart.png"
          alt="cart"
        />
      </a>
      <button class="menu" @click="$emit('onClickMenu')">
        <img
          src="https://d33wubrfki0l68.cloudfront.net/01256149d6b426e896299dca6ce14b94d011e4de/ed0d9/img/icons/hamberger.png"
          alt="menu"
        />
      </button>
    </div>
  </header>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.the-header {
  display: flex;
  justify-content: space-between;
  height: 64px;

  .icons {
    display: flex;

    > a,
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 64px;
      height: 64px;
      cursor: pointer;

      > img {
        width: 32px;
        object-fit: cover;
      }
    }

    > .cart {
      background: #1c1c3e;
    }

    > .menu {
      background: #ccb35f;
    }
  }

  > .title {
    display: flex;
    padding: 12px 8px;

    > h1 {
      font-weight: normal;
      font-size: 0.6em;
      width: 96px;
    }

    > span {
      height: 40px;
      margin: 0 12px;
      border: 0.5px solid black;
    }

    > img {
      width: 80px;
      height: 40px;
      object-fit: contain;
    }
  }
}
</style>
